module.exports = __webpack_public_path__ + "img/shop.c60da484.png";